import { render } from "./form-import-tahapan-diklat.vue?vue&type=template&id=1f422740"
import script from "./form-import-tahapan-diklat.vue?vue&type=script&lang=js"
export * from "./form-import-tahapan-diklat.vue?vue&type=script&lang=js"

import exportComponent from "/home/alfahuma/manual_build/digita-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__